import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./blockPostGridGeneric.scss"
import Title from "../../common/title"
import parse from "html-react-parser"
import Media from "../../common/media"
import { generateUrlByLocale } from "../../../services/intl.service"
import { graphql, Link } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"

const BlockPostGridGeneric = ({ content }) => {
  const intl = useIntl()
  const [, ...lists] = content.relationships.block_post_grid_items

  return (
    <section className="blk-post-grid-generic blk-spacing">
      <Container>
        <Row>
          <Col md={6} className="blk-text-media-full-generic-content">
            <span className="caption">
              <span>{content.block_post_grid_caption}</span>
            </span>
            <Title size={3} text={content.block_post_grid_title} />
          </Col>
          <Col md={6}>
            {parse(content.block_post_grid_description.processed)}
            {content.block_post_grid_factsheet_title && (
                <Link className="simpleLink" href={content.relationships.block_post_grid_factsheet?.relationships.field_media_file.publicUrl} target="_blank">
                  {content.block_post_grid_factsheet_title}
                </Link>
            )}
          </Col>
        </Row>
        <Row className="blkGridItem">
          <div className="blkItem">
            {content.relationships.block_post_grid_items.length > 0 &&
              (content.relationships.block_post_grid_items[0].relationships
                .featured_media_landscape ? (
                <Media
                  media={
                    content.relationships.block_post_grid_items[0].relationships
                      .featured_media_landscape?.relationships
                      .featured_media_media
                  }
                />
              ) : (
                ""
              ))}
            {content.relationships.block_post_grid_items.length > 0 && (
              <Title
                heading={3}
                size={2}
                text={content.relationships.block_post_grid_items[0].title}
              />
            )}
            {content.relationships.block_post_grid_items.length > 0 && (
              <>
                <p className="description">
                  {parse(
                    content.relationships.block_post_grid_items[0].relationships
                      .introduction.introduction_description
                      .processed
                  )}
                </p>
                <Link
                  className="simpleLink"
                  to={generateUrlByLocale(
                    content.relationships.block_post_grid_items[0].path
                      .langcode,
                    content.relationships.block_post_grid_items[0].path.alias
                  )}
                >
                  {intl.formatMessage({ id: "learn_more" })}
                </Link>
              </>
            )}
          </div>
          {lists.map((list, index) => {
            const linkPath = generateUrlByLocale(
              list.path.langcode,
              list.path.alias
            )
            return (
              <div className={"blkItem blkItem-"+index}>
                <div className="illusLandscape">
                  {list.relationships.featured_media_landscape && (
                      <Link
                          to={linkPath}
                          key={index}
                      >
                        <Media
                            media={
                              list.relationships.featured_media_landscape
                                  ?.relationships.featured_media_media
                            }
                        />
                      </Link>
                  )}
                </div>
                <div className="illusPortrait">
                  {list.relationships.featured_media_portrait && (
                      <Link
                          to={linkPath}
                          key={index}
                      >
                        <Media
                            media={
                              list.relationships.featured_media_portrait
                                  ?.relationships.featured_media_media
                            }
                        />
                      </Link>
                  )}
                </div>
                <div className="blk-article-infos">
                  <h3 className="font-style_2 primaryCol">
                    <Link
                      to={linkPath}
                      key={index}
                    >
                      {list.title}
                    </Link>
                  </h3>
                  <p className="description">
                    {parse(
                      list.relationships
                        .introduction.introduction_description
                        .processed
                    )}
                  </p>
                  <Link
                    className="simpleLink"
                    to={generateUrlByLocale(
                      list.path
                        .langcode,
                      list.path.alias
                    )}
                  >
                    {intl.formatMessage({ id: "learn_more" })}
                  </Link>
                </div>
              </div>
            )
          })}
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment postGrid on paragraph__block_post_grid {
    internal {
      type
    }
    block_post_grid_caption
    block_post_grid_description {
      processed
    }
    block_post_grid_title
    block_post_grid_factsheet_title
    relationships {
      block_post_grid_factsheet {
        relationships {
          field_media_file {
            publicUrl
          }
        }
      }
      block_post_grid_items {
        ... on node__generic {
          title
          path {
            alias
            langcode
          }
          relationships {
            featured_media_portrait: generic_featured_media {
              ...getFeaturedMedia
            }
            featured_media_landscape: generic_featured_media_landscape {
              ...getFeaturedMedia
            }
            introduction: generic_introduction {
              introduction_description {
                processed
              }
            }
          }
        }
        ... on node__activity {
          title
          path {
            alias
            langcode
          }
          relationships {
            featured_media_portrait: activity_featured_portrait {
              ...getFeaturedMedia
            }
            featured_media_landscape: activity_featured_landscape {
              ...getFeaturedMedia
            }
            introduction: activity_introduction {
              introduction_description {
                processed
              }
            }
          }
        }
      }
    }
  }
`

export default BlockPostGridGeneric
